import mitt from "mitt";
var emitter = mitt();
emitter.once = function (type, fn) {
    emitter.on(type, fn);
    emitter.on(type, emitter.off.bind(emitter, type, fn));
};
var eventHandler = {
    $on: emitter.on,
    $once: emitter.once,
    $off: emitter.off,
    $emit: emitter.emit,
};
window.GD = window.GD || {};
// register hidden - it's bad practice when we register here directly
// to GD.event (registration on GD will be in the classic-gd module)
var eventBus = (window.GD.__eventBus = window.GD.__eventBus || eventHandler);
export default eventBus;
//# sourceMappingURL=EventBus.js.map